import { Link } from 'react-router-dom';
import { useNotifications } from './notification-context';

/**
 * The one action that is due soonest. It stays until the player does the
 * thing, or the lock passes. Reading the inbox does not dismiss it.
 */
export function ActionBanner() {
  const { inbox, openInbox } = useNotifications();
  const banner = inbox?.banner;
  if (!banner) {
    return null;
  }

  return (
    <div className="mb-4 flex items-center justify-between gap-3 rounded-control border border-danger/40 bg-danger/10 px-4 py-3">
      <Link to={banner.href} className="min-w-0 text-[13px] font-bold leading-snug">
        {banner.body}
      </Link>
      {banner.extra > 0 ? (
        <button
          type="button"
          onClick={openInbox}
          className="shrink-0 text-[11px] font-extrabold uppercase tracking-[0.04em] text-danger"
        >
          +{banner.extra} more
        </button>
      ) : null}
    </div>
  );
}

/** A dot while an action is waiting on this destination. */
export function NavAttention({ on }: { on: boolean }) {
  if (!on) {
    return null;
  }
  return (
    <span
      aria-hidden="true"
      className="absolute -right-0.5 -top-0.5 size-1.5 rounded-full bg-danger"
    />
  );
}
